import { render, staticRenderFns } from "./CollectionContentHeader.vue?vue&type=template&id=023b3431&scoped=true"
import script from "./CollectionContentHeader.vue?vue&type=script&lang=js"
export * from "./CollectionContentHeader.vue?vue&type=script&lang=js"
import style0 from "./CollectionContentHeader.vue?vue&type=style&index=0&id=023b3431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b3431",
  null
  
)

export default component.exports